<template>
	<div
		class="g-block-image-grid"
		:class="{
			'g-block-image-grid--edit': editable,
			'is-active': editable && active,
			'g-block-image-grid--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-image-grid__list">
			<div
				v-for="(item, index) in items"
				:key="item.id"
				class="g-block-image-grid__item"
			>
				<div
					class="g-block-image-grid__thumb"
					:class="{ 'is-previewable': isPreviewable }"
					:style="thumbStyle"
					@click="onThumbClick(index, $event)"
				>
					<img v-if="getImageUrl(item)" :src="getImageUrl(item)" alt="" />
					<i v-else class="mbm-iconfont mbm-tupian"></i>
				</div>
				<div
					class="g-block-image-grid__title"
					:style="{ color: gridStyle.textColor }"
				>
					{{ item.title }}
				</div>
			</div>
		</div>

		<ImageGalleryLightbox
			v-model:visible="lightboxVisible"
			:urls="lightboxUrls"
			:initial-index="lightboxIndex"
		/>
	</div>
</template>

<script>
	import ImageGalleryLightbox from '../../../components/ImageGalleryLightbox.vue';
	import {
		getImageGridImageUrl,
		getImageGridItemStyle,
		normalizeImageGridData,
	} from '../../../utils/imageGrid.js';

	export default {
		name: 'GImageGridShell',
		components: { ImageGalleryLightbox },
		props: {
			data: {
				type: Object,
				required: true,
			},
			editable: {
				type: Boolean,
				default: false,
			},
			active: {
				type: Boolean,
				default: false,
			},
			h5: {
				type: Boolean,
				default: false,
			},
		},
		emits: ['select'],
		data() {
			return {
				lightboxVisible: false,
				lightboxUrls: [],
				lightboxIndex: 0,
			};
		},
		computed: {
			normalizedData() {
				return normalizeImageGridData(this.data);
			},
			items() {
				return this.normalizedData.items;
			},
			gridStyle() {
				return getImageGridItemStyle(this.data, { h5: this.h5 });
			},
			thumbStyle() {
				return {
					aspectRatio: this.gridStyle.aspectRatio,
					borderRadius: this.gridStyle.borderRadius,
				};
			},
			isPreviewable() {
				return this.h5 && !this.editable;
			},
		},
		methods: {
			getImageUrl(item) {
				return getImageGridImageUrl(item.image);
			},
			getGalleryUrls() {
				return this.items.map(item => this.getImageUrl(item)).filter(Boolean);
			},
			onWrapClick(e) {
				if (!this.editable) return;
				e?.stopPropagation?.();
				this.$emit('select');
			},
			onThumbClick(index, e) {
				if (!this.isPreviewable) return;
				e?.stopPropagation?.();
				const urls = this.getGalleryUrls();
				if (!urls.length) return;
				this.lightboxUrls = urls;
				this.lightboxIndex = Math.min(index, urls.length - 1);
				this.lightboxVisible = true;
			},
		},
	};
</script>

<style scoped lang="less">
	.g-block-image-grid {
		width: 100%;
		box-sizing: border-box;

		&--edit {
			border: 1px solid transparent;
			border-radius: 4px;
			transition: border-color 0.2s, box-shadow 0.2s;
			cursor: pointer;

			&.is-active {
				border-color: #285af9;
				box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15);
			}
		}
	}

	.g-block-image-grid__list {
		display: grid;
		grid-template-columns: repeat(3, minmax(0, 1fr));
		gap: 12px;
		width: 100%;

		.g-block-image-grid--h5 & {
			gap: 0.24rem;
		}
	}

	.g-block-image-grid__item {
		min-width: 0;
	}

	.g-block-image-grid__thumb {
		width: 100%;
		height: auto;
		overflow: hidden;
		background: #f0f0f0;
		display: flex;
		align-items: center;
		justify-content: center;

		&.is-previewable {
			cursor: pointer;
		}

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			display: block;
		}

		i {
			font-size: 24px;
			color: #bfbfbf;
		}

		.g-block-image-grid--h5 & i {
			font-size: 0.48rem;
		}
	}

	.g-block-image-grid__title {
		margin-top: 8px;
		font-size: 14px;
		font-weight: 600;
		line-height: 1.4;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;

		.g-block-image-grid--h5 & {
			margin-top: 0.16rem;
			font-size: 0.28rem;
		}
	}
</style>
